import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import { PureButton } from '../../basics';
import { ButtonSize, WishlistButtonType } from '../../enums';
import { CloseIcon, HeartFilledIcon, HeartIcon } from '../Icons';
import styles from './WishlistButton.module.scss';
const WishlistButton = forwardRef(({ a11yText, className, isActive = false, isTransparent = false, size = ButtonSize.Large, touchableArea = ButtonSize.Large, wishlistButtonType = WishlistButtonType.Default, ...restProps }, ref) => {
    const showHeartIcon = wishlistButtonType !== WishlistButtonType.RemoveOnly;
    const buttonClasses = classNames('d-inline-flex align-items-center justify-content-center', styles.button, styles.primaryLight, styles[`ui-${size}`], styles[`touch-${touchableArea}`], {
        [styles.hasBorder]: wishlistButtonType === WishlistButtonType.WithOutline,
        [styles.isActive]: isActive,
        [styles.isTransparent]: isTransparent,
    }, className);
    return (_jsxs(PureButton, { className: buttonClasses, "aria-label": a11yText, ref: ref, ...restProps, children: [!showHeartIcon && _jsx(CloseIcon, { size: 28 }), showHeartIcon &&
                (!isActive ? _jsx(HeartIcon, { size: 28 }) : _jsx(HeartFilledIcon, { size: 28 }))] }));
});
WishlistButton.displayName = WishlistButton.name;
export { WishlistButton };
